//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
import MyAccount from "@/components/User/myAccount.vue";
import tasksDelegation from "@/components/User/tasksDelegation.vue";
import Wallet from "../Wallet/Wallet.vue";

export default {
    components: {
        "my-account": MyAccount,
        Wallet,
        tasksDelegation
    },
    data() {
        return {
            delegationEnabled: false,
            accountTab: "settings",
            settingsModel: true
        };
    },
    computed: {
        ...mapGetters("admin", ["featuresByTenant"])
    },
    created() {
        this.delegationEnabled = this.featuresByTenant.find(element => element.code === "TASK_DELEGATION").enabled;
    }
};
